export default "__VITE_ASSET__BA0EB7SH__"